<template>
    <app-layout>
        <template #header>
            <div v-if="$page.props.labels['contact.title'] || $page.props.labels['contact.text']" class="text-center">
                <h2 class="text-2xl text-black leading-tight mb-2" v-if="$page.props.labels['contact.title']">{{$page.props.labels['contact.title']}}</h2>
                <p class="text-base font-serif" v-if="$page.props.labels['contact.text']">{{$page.props.labels['contact.text']}}</p>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div
                    v-for="(contact, key) in $page.props.contacts"
                    :key="contact.id"
                    :class="[
                        'py-12 border-b px-4 flex flex-col items-center justify-center sm:px-0 sm:flex-row',
                        { 'border-transparent': key === $page.props.contacts.length - 1 }
                    ]">
                    <img class="sm:mr-8 block w-64 h-64 rounded-full mb-4 sm:mb-0" width="256" height="256" :src="contact.full_image" :alt="`${contact.first_name} ${contact.last_name}`">
                    <div class="min-w-lg max-w-lg w-full">
                        <h2 class="text-xl">{{ `${contact.first_name} ${contact.last_name}` }}</h2>
                        <p class="mb-4">{{ contact.responsibility }}</p>
                        <p>
                            <template v-if="contact.phone"><span class="inline-block w-24 font-semibold">Telefon:</span> <a :href="`tel:${contact.phone}`">{{ contact.phone }}</a><br></template>
                            <template v-if="contact.fax"><span class="inline-block w-24 font-semibold">Fax:</span> {{ contact.fax }} <br></template>
                            <template v-if="contact.email"><span class="inline-block w-24 font-semibold">E-Mail:</span>  <a class="underline hover:no-underline focus:opacity-70" :href="`mailto:${contact.email}`">{{ contact.email }}</a></template>
                        </p>
                        <div v-if="contact.description" class="my-4 font-serif leading-7">
                            {{ contact.description }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import Welcome from '@/Jetstream/Welcome'

    export default {
        components: {
            AppLayout,
            Welcome,
        },
    }
</script>
